import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

function PortfolioIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <svg
      {...svgProps}
      viewBox="28 13 23 23"
      role="presentation"
    >
      <path
        d="M47.577 25.712c0 5.13-4.16 9.288-9.29 9.288C33.16 35 29 30.84 29 25.712c0-5.13
           4.16-9.29 9.288-9.29v9.29h9.29zM40.712 14C45.842 14 50 18.16 50 23.288h-9.288V14z"
        stroke={color}
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
}

PortfolioIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

PortfolioIcon.defaultProps = {
  height: 21,
  width: 21,
};

export default pure(PortfolioIcon);
